import { createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-3279f39a")

_pushScopeId("data-v-3279f39a")
const _hoisted_1 = { class: "google-account" }
const _hoisted_2 = { class: "name-wrap" }
const _hoisted_3 = { class: "name" }
const _hoisted_4 = { class: "email" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", {
      class: ["avatar-wrap", {'changed': _ctx.isProfile}]
    }, [
      _createVNode("img", {
        class: "avatar",
        src: _ctx.avatar
      }, null, 8, ["src"])
    ], 2),
    _createVNode("div", _hoisted_2, [
      _createVNode("p", _hoisted_3, _toDisplayString(_ctx.userName), 1),
      _createVNode("p", _hoisted_4, _toDisplayString(_ctx.email), 1)
    ])
  ]))
})